import React from 'react';
import { Label, Icon } from '@nooz-optics/nooz-components-lib';
import {
  IBlock,
  IButton,
  IImage,
  ILabel,
} from '../../../../utils/types/contentful';
import { Link } from '../../../UI/Elements/Link';
import { withLocale } from '../../../../utils/hocs';

export const SiteMap = withLocale(
  ({
    label,
    collectionLabel,
    blogLabel,
    pages,
    blogPages,
    categories,
    locale,
  }: MainReviewProps) => {
    const returnSiteLink = (slug) => {
      if (!slug) return <></>;

      const label = {
        text: `${process.env.GATSBY_BASE_HOST}${process.env.GATSBY_ZONE}/${locale[0]}/${slug.url}`,
        decoration: 'underline',
      };

      return (
        <div className='my-4'>
          <Link
            slug={slug}
            label={label}></Link>
        </div>
      );
    };

    const returnCategory = (category) => {
      return (
        <div>
          {category.pageReference?.robots !== 'noindex' &&
            returnSiteLink(category.pageReference?.slug)}
          {category.products?.map((product) => {
            if (product.pageReference) {
              return (
                product.pageReference.robots !== 'noindex' &&
                returnSiteLink(product.pageReference?.slug)
              );
            }
          })}
        </div>
      );
    };

    return (
      <div className='py-10 text-center '>
        <Label
          {...label}
          size='5xl'
          type='h1'
        />
        <div className='mt-10'>
          {pages?.map(
            (page) => page.robots !== 'noindex' && returnSiteLink(page.slug)
          )}
          <div className='mt-16'>
            <Label
              {...collectionLabel}
              size='3xl'
              type='h2'
            />
            {categories?.map((category) => returnCategory(category))}
          </div>
          <div className='mt-16'>
            <Label
              {...blogLabel}
              size='3xl'
              type='h2'
            />
            {blogPages?.map((page) => returnSiteLink(page.slug))}
          </div>
        </div>
      </div>
    );
  }
);
